/** t622u: the quiet line above the composer when you have messages scheduled here ("1 scheduled message"). */
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { scheduledCountLabel } from '@tradeoutlet/shared';
import { pendingHere, useConversationScheduled } from './scheduledQueries';

export function ScheduledLine({ conversationId, parentId }: { conversationId: string; parentId?: string | null }) {
  const q = useConversationScheduled(conversationId);
  const n = pendingHere(q.data, parentId).length;
  if (!n) return null;
  return (
    <div className="px-1 pb-1 text-xs text-slate-500 dark:text-slate-400" data-testid="composer-scheduled-line">
      <Link to={`/chat/scheduled?c=${conversationId}`} className="inline-flex items-center gap-1 hover:text-slate-800 hover:underline dark:hover:text-slate-200">
        <Clock aria-hidden className="h-3 w-3" />{scheduledCountLabel(n)}
      </Link>
    </div>
  );
}
